if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"plan","remotes":[{"alias":"notification","name":"notification","entry":"/notification/_next/static/chunks/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^((168|373|812)2|1995|348|4270|5871|8594|913)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}